import { Component, input, Input, TemplateRef } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ActionButtonsComponent } from '../../../action/components/action-buttons/action-buttons.component';
import { isNil, Nillable } from '@web/utils';
import { TableRowsSelection } from '../../models/table-rows-selection';
import { ActionButton } from '../../../action/models/action-button';
import { TableCollectionActionsComponent } from '../table-collection-actions/table-collection-actions.component';
import { TableCollectionAction } from '../../models/table-collection-action';
import { TableCustomCollectionActionsTemplateContext } from '../../models/table-custom-collection-actions-template-context';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-table-header',
  imports: [
    CardModule,
    TableCollectionActionsComponent,
    ActionButtonsComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
})
export class TableHeaderComponent<Item, Filter, CollectionAction, Action> {
  @Input() public selection!: Nillable<TableRowsSelection<Item, Filter>>;
  @Input() public actions!: Nillable<ActionButton<Action>[]>;
  @Input() public collectionActions!: Nillable<
    TableCollectionAction<Item, Filter, CollectionAction>[]
  >;

  /* prettier-ignore */
  public readonly customCollectionActionsTemplateRef = input<Nillable<TemplateRef<TableCustomCollectionActionsTemplateContext<Item, Filter>>>>();
  /* prettier-ignore */
  public readonly customActionsTemplateRef = input<Nillable<TemplateRef<void>>>();

  protected readonly isNil = isNil;
}
